import React, { Fragment } from 'react';

function getDesign(messageListPwdChange) {

  return (
    <Fragment>
      <div className="contentInner">
        <div className="ds-heading ds-heading--sm">
          <h2 className="ds-heading__title">{messageListPwdChange.M013_notices}</h2>
        </div>
        <ul className="ds-listText ds-listText--md">
          <li className="ds-listText__item">{messageListPwdChange.M014_notice001}</li>
        </ul>
      </div>
    </Fragment>
  );
}

export { getDesign }
